import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AnnualReportBusinessModel } from '@modeso/aumico-lib-annualreport-fe';
import { IAumMenuDelegate, InlineTableCellEditComponent } from '@modeso/aumico-lib-core-fe';
import { ItemType } from '@modeso/types__aumico-lib-annualreport-be';
import { MenuAction } from '../../../enums/menu-action.enum';
import { MenuItemCreator } from '../../../helpers/menu-item-creator.helper';
import { MenuItemList } from '../../../interfaces/menu-item-list.class';
import { Item } from '../../../interfaces/menu-item.class';

@Component({
    selector: 'menu-list-for-mapping',
    templateUrl: './menu-list-for-mapping.component.html',
    styleUrls: ['./menu-list-for-mapping.component.scss'],
    providers: [MenuItemCreator],
})
export class MenuListForMappingComponent implements OnInit, IAumMenuDelegate, OnChanges {
    @Input() item: Item;
    @Input() parentType?: ItemType;
    @Input() isHighestLevelParent?: boolean;
    @Input() cellComponent: InlineTableCellEditComponent;
    @Input() isBalanceSwitchAccountDisabled: boolean;
    @Input() isAddAccountDisabled: boolean;
    @Input() disableEditingAnnualProfitValue = false;
    @Input() businessModel: string;
    @Input() supportOperation = false;
    @Input() isAutomaticTransferOfAnnualResultEnabled: boolean | undefined = undefined;

    @Output() onClickEmitter = new EventEmitter<MenuAction>();

    menuItemList: MenuItemList;

    constructor(
        private menuItemCreator: MenuItemCreator,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {
        this.addSvgIcon('aumico-pattern-icon-settings-vertical');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['supportOperation'] || changes['isAddAccountDisabled'] || changes['isAutomaticTransferOfAnnualResultEnabled']) {
            this.menuItemList = this.menuItemCreator.createMenuItem(
                this.item,
                this.businessModel,
                this.parentType,
                this.isBalanceSwitchAccountDisabled,
                this.isAddAccountDisabled,
                this.isHighestLevelParent,
                this.supportOperation,
                this.disableEditingAnnualProfitValue,
                this.isAutomaticTransferOfAnnualResultEnabled
            );
        }

    }

    onMenuItemClick(action: MenuAction): void {
        this.onClickEmitter.emit(action);
        if (action == MenuAction.DISABLE_FLI_NUMBERING || action == MenuAction.ENABLE_FLI_NUMBERING)
            this.menuItemList = this.menuItemCreator.createMenuItem(
                this.item,
                this.businessModel,
                this.parentType,
                this.isBalanceSwitchAccountDisabled,
                this.isAddAccountDisabled,
                this.supportOperation,
                this.disableEditingAnnualProfitValue,
                this.isAutomaticTransferOfAnnualResultEnabled
            );
    }

    ngOnInit(): void {
        if (this.businessModel != null) {
            this.menuItemList = this.menuItemCreator.createMenuItem(
                this.item,
                this.businessModel,
                this.parentType,
                this.isBalanceSwitchAccountDisabled,
                this.isAddAccountDisabled,
                this.isHighestLevelParent,
                this.supportOperation,
                this.disableEditingAnnualProfitValue,
                this.isAutomaticTransferOfAnnualResultEnabled
            );
        } else {
            this.menuItemList = this.menuItemCreator.createMenuItem(
                this.item,
                AnnualReportBusinessModel.OR,
                this.parentType,
                this.isBalanceSwitchAccountDisabled,
                this.isAddAccountDisabled,
                this.isHighestLevelParent,
                this.supportOperation,
                this.disableEditingAnnualProfitValue,
                this.isAutomaticTransferOfAnnualResultEnabled
            );
        }
        const icons = this.menuItemList.items.map((item) => item.icon);
        this.registerIcons(icons);
    }

    private addSvgIcon(name: string) {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    private registerIcons(icons: string[]): void {
        for (const icon of icons) {
            const iconUrl: SafeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${icon}`);
            this.matIconRegistry.addSvgIcon(icon, iconUrl);
        }
    }
}
